import { useEnmonServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { GetLicensesAnalysisResponse, GetLicensesAnalysisArg } from 'lib/services';
import { type UseQueryResult, useQuery } from 'react-query';
import { QUERY_KEYS } from 'utils/queryKeys';
import { getErrorMessage } from 'utils/getErrorMessage';

export const useLicensesAnalysis = (filter: GetLicensesAnalysisArg): UseQueryResult<GetLicensesAnalysisResponse> => {
  const { analysisApiClient } = useEnmonServices();
  const notify = useAppNotifications();

  return useQuery(
    QUERY_KEYS.customers.licensesAnalysis(filter),
    async ({ signal }) => await analysisApiClient.getLicenses(filter, signal),
    {
      retry: false,
      onError: error =>
        notify.error({
          message: 'There was an error while fetching licenses analysis data',
          description: getErrorMessage(error),
        }),
    },
  );
};
